import { useTranslation } from 'react-i18next';

/**
 * One-line reminder under lesson text fields: links typed in the text become
 * buttons for students automatically, and `[Text](https://…)` (or
 * `(Text)[https://…]`) sets the button text. Nothing to fill in.
 */
export function LessonLinkHint() {
  const { t } = useTranslation('admin');
  return (
    <p className="mt-1 text-xs text-muted-foreground">
      {t('classes.form.classContent.linkHint')}
    </p>
  );
}
